import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useIsTextConversation } from '@/entities/conversations';
import { cn } from '@/shared/lib';
import { DialogAudioSection } from '../DialogAudioSection/DialogAudioSection';
import { DialogListSection, type DialogListSectionProps } from '../dialogsListSection/DialogListSection';
import { SessionDetails } from '../SessionDetails/SessionDetails';

type Props = {
  listSection?: FC<DialogListSectionProps>;
};

export const DialogVisualizerLayout: FC<Props> = ({ listSection }) => {
  const { id } = useParams<{ id: string }>();
  const ListSection = listSection ?? DialogListSection;
  // Блока записи у текстовой коммуникации нет — карточка занимает всю высоту
  const isTextConversation = useIsTextConversation(id);

  if (!id) {
    return <ListSection className="h-full relative w-full" />;
  }

  return (
    <div
      className={cn('grid grid-cols-1 gap-4 h-full', isTextConversation ? 'grid-rows-[1fr]' : 'grid-rows-[auto_1fr]')}
    >
      <DialogAudioSection />
      <SessionDetails id={+id} />
    </div>
  );
};
